import { useState, useMemo } from "react"
import { ProjectProps } from "../../../interfaces/project_types"

// So far only searches for project name, client name, and city
export function useSearchBar(projects: ProjectProps[] | undefined) {
    const [searchTerm, setSearchTerm] = useState<string>("")

    // Filter projects based on search term
    const filteredProjects = useMemo(() => {
        if (!projects || !searchTerm.trim()) return projects

        return projects.filter(proj => {
            const searchLower = searchTerm.toLowerCase()
            return (
                proj.project_name?.toLowerCase().includes(searchLower) ||
                proj.client?.name?.toLowerCase().includes(searchLower) ||
                proj.city?.toLowerCase().includes(searchLower)
            )
        })
    }, [projects, searchTerm])

    // Get filtered clients based on filtered projects
    const filteredClients = useMemo(() => {
        if (!filteredProjects) return []
        const unique_clients = [...new Set(filteredProjects.map(project => project.client?.name))]
        return unique_clients as string[]
    }, [filteredProjects])

    const handleSearchChange = (value: string) => {
        setSearchTerm(value)
    }

    const handleClearSearch = () => {
        setSearchTerm("")
    }

    return {
        searchTerm,
        filteredProjects,
        filteredClients,
        handleSearchChange,
        handleClearSearch
    }
}
